module.exports = __webpack_public_path__ + "img/download.812ba794.svg";